"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAY_YESTERDAY_COPY = exports.DAY_TODAY_COPY = void 0;
exports.dayGroupLabel = dayGroupLabel;
const apiDates_1 = require("./apiDates");
/**
 * The Transactions list's section headings, one per calendar day, as Anthony's
 * Transactions redesign draws them: "Today, Sep 15", "Yesterday, Sep 14", "Sep 12".
 * The year is added when it is not the current year ("Dec 30, 2025"), because a list
 * that reaches back past January would otherwise print two "Sep 12" headings a year
 * apart.
 *
 * Moved verbatim from mobile's `lib/transactionListSections.ts` (Transactions Phase 1,
 * 2026-10-08, rule 17) so both clients head a day the same way. Web grouped by MONTH
 * after Today/Yesterday until then.
 *
 * `parseApiDate`, not `new Date(iso)`: a bare date-only string parses as UTC midnight,
 * which is the PREVIOUS day in any negative-offset zone, so a row dated today was
 * filed under "Yesterday" while the row itself printed "Today" (BEN-141 M8,
 * photographed in America/Los_Angeles).
 */
/** The two relative day words, as constants so the copy inventory lists them. */
exports.DAY_TODAY_COPY = "Today";
exports.DAY_YESTERDAY_COPY = "Yesterday";
function dayGroupLabel(iso, now = new Date()) {
    const d = (0, apiDates_1.parseApiDate)(iso);
    const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // Rounded: a day across a DST change is 23 or 25 hours long.
    const days = Math.round((today.getTime() - day.getTime()) / 86400000);
    const date = (0, apiDates_1.formatApiDate)(day, day.getFullYear() === now.getFullYear() ? "short" : "shortWithYear");
    if (days === 0)
        return `${exports.DAY_TODAY_COPY}, ${date}`;
    if (days === 1)
        return `${exports.DAY_YESTERDAY_COPY}, ${date}`;
    return date;
}
//# sourceMappingURL=dayGroupLabel.js.map